import Postmonger from 'vis-postmonger';

import {
  decisionSplitInteractionLoaded,
  initDecisionSplit,
  requestsMovingToOtherStep,
  setToken,
  types,
} from '../../JourneyBuilder/actions/JourneyBuilder';
import { getDecisionSplitSteps } from '../../JourneyBuilder/constants/JourneyBuilder';

const connection = new Postmonger.Session();

export const postmongerMiddleware = store => next => action => {
  switch (action.type) {
    case types.JOURNEY_BUILDER_DECISION_SPLIT_START:
      connection.on('clickedNext', () => store.dispatch(requestsMovingToOtherStep()));
      connection.on('initActivity', data => store.dispatch(initDecisionSplit(data)));
      connection.on('requestedInteraction', interaction => {
        store.dispatch(decisionSplitInteractionLoaded(interaction));
      });
      connection.on('requestedTokens', tokens => store.dispatch(setToken(tokens)));
      connection.trigger('updateSteps', getDecisionSplitSteps());
      connection.trigger('updateButton', {
        button: 'next',
        enabled: false,
      });
      connection.trigger('requestInteraction');
      connection.trigger('requestTriggerEventDefinition');
      connection.trigger('requestTokens');
      connection.trigger('requestEndpoints');
      connection.trigger('ready');
      break;
    case types.JOURNEY_BUILDER_UPDATE_ACTIVITY:
      connection.trigger('updateActivity', action.payload);
      break;
    case types.JOURNEY_BUILDER_CANNOT_MOVE_TO_OTHER_STEP:
      connection.trigger('ready');
      break;
    case types.JOURNEY_BUILDER_UPDATE_DONE_BUTTON:
      connection.trigger('updateButton', { button: 'next', enabled: action.payload });
      break;
    default:
      next(action);
      break;
  }
};

export default postmongerMiddleware;



// WEBPACK FOOTER //
// ./src/Root/RootStore/postmongerMiddleware.js